import { render, staticRenderFns } from "./DotationsView.vue?vue&type=template&id=4a7d45b3"
import script from "./DotationsView.vue?vue&type=script&lang=js"
export * from "./DotationsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports